/**
 * Zet de bevestigingsschroeven van de nummerplaat-preview exact op de opgemeten gaten van de houder.
 * Gaten staan per product in snippets/noir-preview-map.liquid (veld 6, fotocoordinaten lb, rb, lo, ro).
 */
(function () {
  'use strict';
  function apply() {
    var pending = false;
    document.querySelectorAll('[data-np-holes]').forEach(function (h) {
      if (h.dataset.npDone) return;
      var root = h.closest('[data-np-root]');
      var layer = root && root.querySelector('[data-np-layer]');
      var g = layer && layer.querySelector('g.np-plate');
      if (!g) { pending = true; return; }
      var holes;
      try { holes = JSON.parse(h.getAttribute('data-np-holes')); } catch (e) { return; }
      if (!holes || holes.length !== 4) return;
      var t = g.transform && g.transform.baseVal && g.transform.baseVal.consolidate();
      if (!t) return;
      var inv = t.matrix.inverse();
      var screws = [].filter.call(g.children, function (c) { return c.tagName.toLowerCase() === 'circle'; });
      if (screws.length !== 4) return;
      screws.forEach(function (c, i) {
        var x = holes[i][0], y = holes[i][1];
        c.setAttribute('cx', inv.a * x + inv.c * y + inv.e);
        c.setAttribute('cy', inv.b * x + inv.d * y + inv.f);
      });
      h.dataset.npDone = '1';
    });
    return pending;
  }
  var tries = 0;
  function run() { if (apply() && tries++ < 40) setTimeout(run, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', function () { tries = 0; run(); });
})();
